<template lang="pug">
  .d-inline-block
    v-card.round-lg.mt-4.mb-8.pa-4.card-style
      .text-xl.font-semibold +{{ pointCount }} {{ 'pt' | pluralize({ count:pointCount }) }}
      .text-xl.font-semibold(style="color: #814711") {{ 'point' | pluralize({ count:pointCount }) }} added
    .text-lg.font-semibold.mb-4.neutral700--text {{ name }} has received {{ pointCount }} {{ 'point' | pluralize({ count:pointCount }) }}!
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    pointCount: {
      type: Number,
      default: 0
    },
  },
}
</script>

<style scoped>
.card-style {
  background: linear-gradient(180deg, #FFD88C 0%, #DAA02F 100%) !important;
  box-shadow: 0px 4px 14.8px 0px #FFBA5280 !important;
}
</style>